import { Flex, Icon, Text, useToast } from '@chakra-ui/react';
import { FaFileUpload } from 'react-icons/fa';
import { api } from '../../../services/api';
import { useMutation } from 'react-query';

async function uploadFile({ numeroNota, numeroPedido, codigoProduto, sequencia, file }) {
  const formData = new FormData();
  formData.append('numero_nota', numeroNota);
  formData.append('numero_pedido', numeroPedido);
  formData.append('codigo_produto', codigoProduto);
  formData.append('sequencia', sequencia);
  formData.append('imagem[]', file);

  const response = await api.post('/site/v2/orcamento-crm/upload-dados-variaveis', formData);

  return response.data;
}

export const UploadButton = ({ id, name, item, dadosPedido }) => {
  const toast = useToast({
    position: 'top-right',
    isClosable: true
  });

  const { mutateAsync } = useMutation({
    mutationFn: uploadFile,
    onSuccess: () => {
      toast({
        title: 'Arquivo enviado com sucesso',
        status: 'success'
      });
    },
    onError: () => {
      toast({
        title: 'Erro ao enviar arquivo',
        status: 'error'
      });
    }
  });

  async function handleChange(event) {
    const file = event.target.files[0];

    await mutateAsync({
      numeroNota: dadosPedido.numero_nota,
      numeroPedido: dadosPedido.numero_pedido,
      codigoProduto: item.codigo_produto,
      sequencia: item.sequencia,
      file
    });
  }

  return (
    <>
      <Flex flexDir="column" gap={1} alignItems="center" rel="noreferrer" as="label" htmlFor={id}>
        <Text color="#378BBF" as="label" htmlFor="aprovar">
          Upload dados variáveis
        </Text>
        <Icon as={FaFileUpload} color="#378BBF" boxSize="32px" cursor="pointer" />
      </Flex>

      <input type="file" hidden id={id} name={name} onChange={handleChange} />
    </>
  );
};
